import axios from 'axios'
import { BASE_URL, BASE_V2_URL } from '@/constants'
import { magentaOAuth } from '@leapsight/styleguide'
import store from '@/store'

export default async function API_request(endpoint, payload, method) {
  let url = store.getters.hasScheduledReportRole ?  BASE_V2_URL+"/"+endpoint : BASE_URL+"/"+endpoint

  // agrego un trailing slash si no lo tiene
  if (!/\/$/.test(url)){
    url += "/"
  }

  const axiosApiInstance = axios.create();
  
  // Request interceptor for API calls
  axiosApiInstance.interceptors.request.use(
    async config => {
      const token = localStorage.getItem('ACCESS_TOKEN')
      config.data = payload
      config.method = method
      config.responseType = endpoint.includes('download') ? 'blob' : 'json'
      config.headers = { 
        'token': `${token}`,
      }      
      return config;
    },
    error => {
      Promise.reject(error)
  });
  
  // Response interceptor for API calls
  axiosApiInstance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const access_token = await magentaOAuth.refreshToken();            
      axios.defaults.headers.common['token'] = access_token;
      return axiosApiInstance(originalRequest);
    }
    return Promise.reject(error);
  });
  
  let response = axiosApiInstance(url, payload)

  return response

}
